import { ARTICLES_LIMIT } from '../../utils/constants';
import {
    FETCH_ARTICLES_PROJEKTE_CLEAN_UP,
    FETCH_ARTICLES_PROJEKTE_FAILURE,
    FETCH_ARTICLES_PROJEKTE_REQUEST,
    FETCH_ARTICLES_PROJEKTE_SUCCESS,
    UPDATE_PROJEKTE_PAGE_START_PARAM,
} from '../constants/projekteTypes';

const initialState = {
    loading: false,
    articles: [],
    error: '',
    start: 0,
};

const articlesProjekteReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ARTICLES_PROJEKTE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ARTICLES_PROJEKTE_SUCCESS:
            return {
                loading: false,
                articles: action.payload.articles,
                error: '',
                start: state.start,
            };
        case FETCH_ARTICLES_PROJEKTE_FAILURE:
            return {
                loading: false,
                articles: [],
                error: action.payload,
            };
        case FETCH_ARTICLES_PROJEKTE_CLEAN_UP:
            return {
                ...state,
                articles: [],
                error: '',
                loading: false,
                start: 0,
            };
        case UPDATE_PROJEKTE_PAGE_START_PARAM:
            return {
                ...state,
                start: state.start + ARTICLES_LIMIT,
            };
        default:
            return state;
    }
};

export default articlesProjekteReducer;
